import React from 'react';

import {PlaceholderWrapperComponent} from "../../../placeholder/placeholder-wrapper";

export const PredictionPlaceholderVoting = (props) => {
  return (
    <PlaceholderWrapperComponent className={'prediction-placeholder-voting-container'}>
      <div className={'prediction-placeholder-buttons-content'}>
        <div className={'prediction-placeholder-button'}/>
        <div className={'prediction-placeholder-button'}/>
        <div className={'prediction-placeholder-button'}/>
      </div>
    </PlaceholderWrapperComponent>
  )
}
